import '../css/toggle.css'


export const ToggleTheme = ({ handleChange, isChecked }) => {

    return (
        <div className="themeGroup">
        
            <div className="toggle-container">
                <input type="checkbox" id="check" className="toggle" onChange={handleChange} checked={isChecked}/>
                <label htmlFor="check"></label>
            </div>
          
        </div>
       
    );
}
 